module.exports = __webpack_public_path__ + "media/images/guide-9t-f7dc69952792256be711804011496a92.png";